import React, { useEffect, useState } from "react";
import { FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import "./Reviews.css";

const reviews = [
  {
    id: 1,
    name: "Ramesh K.",
    country: "India",
    image:
      "https://randomuser.me/api/portraits/men/32.jpg",
    review:
      "Very impressive customer service! The staff guided me gently on which mukhi to choose based on my needs rather than trying to push expensive options. The bead arrived properly energized and nicely packaged. Thank you for such an honest and reliable service!",
  },
  {
    id: 2,
    name: "Dinesha K.",
    country: "India",
    image: null,
    review:
      "Excellent! Very good customer service. Due to our tight schedule, the staff agreed to deliver the Rudraksha after modification to our hotel. As we moused our bus, the staff at the door also helped us arrange a cab to our hotel.",
  },
  {
    id: 3,
    name: "Suraj P.",
    country: "India",
    image:
      "https://randomuser.me/api/portraits/men/44.jpg",
    review:
      "Best place to buy 100% authentic highest quality Nepali Rudraksha, they have an interactive app with built-in AI system that thoroughly guides on everything right from selecting the most suitable beads to guidance on how to wear and every doubt that one can have regarding Rudraksha.",
  },
  {
    id: 4,
    name: "Amit S.",
    country: "India",
    image:
      "https://randomuser.me/api/portraits/men/52.jpg",
    review:
      "Amazing experience from start to finish. The team was very helpful in explaining the different Rudraksha options and helped me choose the right one according to my requirements.",
  },
  {
    id: 5,
    name: "Priya M.",
    country: "India",
    image:
      "https://randomuser.me/api/portraits/women/44.jpg",
    review:
      "Really happy with the quality and packaging. The product looked beautiful and the support team answered all my questions patiently. Highly recommended for anyone looking for authentic Rudraksha.",
  },
  {
    id: 6,
    name: "Rahul K.",
    country: "India",
    image:
      "https://randomuser.me/api/portraits/men/68.jpg",
    review:
      "One of the best experiences I have had while purchasing Rudraksha online. Everything was explained clearly and the delivery was also very smooth.",
  },
];

// showPhotos={false} drops customer pictures (letter avatars are shown instead).
const Reviews = ({ showPhotos = true }) => {
  const [current, setCurrent] = useState(0);

  // Desktop = 3 cards
  // Tablet = 2 cards
  // Mobile = 1 card
  const [cardsPerView, setCardsPerView] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 600) {
        setCardsPerView(1);
      } else if (window.innerWidth <= 991) {
        setCardsPerView(2);
      } else {
        setCardsPerView(3);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const maxIndex = reviews.length - cardsPerView;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => {
        if (prev >= maxIndex) {
          return 0;
        }

        return prev + 1;
      });
    }, 4500);

    return () => clearInterval(interval);
  }, [maxIndex]);

  const nextSlide = () => {
    setCurrent((prev) => {
      if (prev >= maxIndex) {
        return 0;
      }

      return prev + 1;
    });
  };

  const prevSlide = () => {
    setCurrent((prev) => {
      if (prev <= 0) {
        return maxIndex;
      }

      return prev - 1;
    });
  };

  const goToSlide = (index) => {
    setCurrent(index);
  };

  return (
    <section className="reviews-section">
      <div className="reviews-container">
        <div className="reviews-heading">
          <h2>
            Experience With{" "}
            <span>Astro Logical Solutions</span>
          </h2>
         <div className="about-heading-line">
          <img
            src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
            alt="Heading decoration"
          />
        </div>

          <p>
            Verified reviews from real seekers, across every corner of the
            world.
          </p>
        </div>
        <div className="reviews-summary">

          <div className="google-review-info">

            <div className="google-icon">
              <FcGoogle />
            </div>

            <div className="google-review-content">
              <h3>Trusted by Thousands All Over India</h3>

              <div className="rating-row">
                <div className="stars">
                  <FaStar />
                  <FaStar />
                  <FaStar />
                  <FaStar />
                  <FaStar />
                </div>

                <span>4.9 rating of 400+ reviews</span>
              </div>
            </div>

          </div>

          <button className="write-review-btn">
            Write a Review
          </button>

        </div>
        <div className="reviews-slider-wrapper">

          <button
            className="review-arrow review-arrow-left"
            onClick={prevSlide}
            aria-label="Previous reviews"
          >
            <FaChevronLeft />
          </button>

          <div className="reviews-slider">
            <div
              className="reviews-track"
              style={{
                transform: `translateX(-${
                  current * (100 / cardsPerView)
                }%)`,
              }}
            >

              {reviews.map((item) => (
                <div
                  className="review-slide"
                  key={item.id}
                >
                  <div className="review-card">

                    {/* Stars */}
                    <div className="card-stars">
                      <FaStar />
                      <FaStar />
                      <FaStar />
                      <FaStar />
                      <FaStar />
                    </div>

                    {/* Review */}
                    <p className="review-text">
                      {item.review}
                    </p>

                    {/* Divider */}
                    <div className="review-divider"></div>

                    {/* Customer */}
                    <div className="review-user">

                      {showPhotos && item.image ? (
                        <img
                          src={item.image}
                          alt={item.name}
                        />
                      ) : (
                        <div className="review-avatar-letter">
                          {item.name.charAt(0)}
                        </div>
                      )}

                      <div className="review-user-info">
                        <h4>{item.name}</h4>
                        <span>{item.country}</span>
                      </div>

                    </div>

                  </div>
                </div>
              ))}

            </div>
          </div>

          <button
            className="review-arrow review-arrow-right"
            onClick={nextSlide}
            aria-label="Next reviews"
          >
            <FaChevronRight />
          </button>

        </div>
        <div className="review-dots">

          {Array.from({
            length: maxIndex + 1,
          }).map((_, index) => (
            <button
              key={index}
              className={`review-dot ${
                current === index ? "active" : ""
              }`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to review slide ${index + 1}`}
            ></button>
          ))}

        </div>
      </div>
    </section>
  );
};

export default Reviews;